module.exports = __webpack_public_path__ + "static/media/scenic-view-of-mountains-during-dawn-1266810.db0683ac.jpg";